export enum AssetAddedBy {
	Advisor = 'advisor',
	Applicant = 'applicant',
}
